import request from '@/utils/request'

let IndexApi = {

  /*基础配置*/
  base(data, errorback) {
    return request._post('/shop/index/base', data, errorback);
  },

  /*商城首页*/
  getCount(data, errorback) {
    return request._post('/shop/index/index', data, errorback);
  },
  getbindClient(data, errorback) {
    return request._get('/shop/passport/bindClient', data, errorback);
  },
  postbindClient(data, errorback) {
    return request._post('/shop/passport/bindClient', data, errorback);
  },
  remind(data, errorback) {
    return request._post('/shop/index/remind', data, errorback);
  },
}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js